module.exports = __webpack_public_path__ + "img/Progress-Report-Process-2-mobile.f7344977.png";